export enum UserRolesEnum {
  instructor = 'ROLE_Instructor',
  student = 'ROLE_Student',
  administrator = 'ROLE_Administrator',
  auditor = 'ROLE_Auditor',
  leadAuditor = 'ROLE_Lead_Auditor',
  systemSupport = 'ROLE_System_Support',
  systemAdmin = 'ROLE_System_Admin',
  preAuth = 'ROLE_Pre_Auth_User',
}
